import TaskHigh from 'assets/images/new-loader/todo/priority/TaskHigh.svg'
import TaskMedium from 'assets/images/new-loader/todo/priority/TaskMedium.svg'
import TaskLow from 'assets/images/new-loader/todo/priority/TaskLow.svg'

export const priority = {
    high: TaskHigh,
    medium: TaskMedium,
    low: TaskLow,
}
